class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus()
      }
    });
  }
  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
    const parentWrap = parentDisplay.querySelector('.parent-wrap');
    this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);


/* SMPR: collapse the vertical sidebar filter panels by default so every filter
   heading is visible without scrolling. A panel the shopper has actually
   filtered on stays open. Added 26 Aug 2026. */
(function collapseSmprFacets() {
  function priceIsActive() {
    return /filter\.v\.price\.(gte|lte)=\d/.test(window.location.search);
  }
  function collapse() {
    document.querySelectorAll('.facets__form-vertical details.facets__disclosure-vertical[open]').forEach(function (panel) {
      if (panel.classList.contains('price__filter')) {
        if (!priceIsActive()) panel.removeAttribute('open');
        return;
      }
      if (!panel.querySelector('input:checked')) panel.removeAttribute('open');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapse);
  } else {
    collapse();
  }
  document.addEventListener('shopify:section:load', collapse);
})();
